import { getFirstBusinessDateOfMonth, getTMinus1 } from '@fortem-monorepo/js-utilities'
import { createFilters, useFilters } from '@fortem-monorepo/react-spa'

export const icReportFilters = createFilters([
  {
    type: 'daterange',
    name: 'dates',
    defaultValue: {
      st_dt: getFirstBusinessDateOfMonth(),
      ed_dt: getTMinus1(),
    },
    params: true,
  },
  {
    type: 'select',
    name: 'fund_name',
    params: true,
  },
  {
    type: 'boolean',
    name: 'force_month_end',
    params: true,
  },
])

export const useICReportFilters = () => useFilters<typeof icReportFilters>()
